enum FORMS_ACTION_TYPES {
  'add_forms' = 'add_forms',
  'clear_forms' = 'clear_forms'
}
export default FORMS_ACTION_TYPES



// WEBPACK FOOTER //
// ./src/store/forms/types.ts